import { events } from './events';
import { subjects } from './subjects';

export const v1 = {
  events,
  subjects,
};
